import { Injectable } from '@angular/core';

import { AuthenticationService } from '../../authentication/service/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class VerificationEventService {
  private readonly baseUrl: string = '/api/booking/verification/events';
  private readonly eventStreams: Map<
    string,
    ReadableStreamDefaultReader | null
  > = new Map();

  constructor(private readonly authService: AuthenticationService) {}

  async connect(uuid: string): Promise<ReadableStreamDefaultReader> {
    if (this.eventStreams.has(uuid)) {
      return this.eventStreams.get(uuid)!;
    }

    const authToken = this.authService.getAuthToken();
    const response = await fetch(`${this.baseUrl}/${uuid}`, {
      method: 'GET',
      credentials: 'include',
      headers: { Authorization: `Bearer ${authToken}` },
      keepalive: true,
    });

    if (!response.ok || !response.body) {
      throw new Error('Failed to connect to event stream');
    }

    const reader = response.body.getReader();
    this.eventStreams.set(uuid, reader);

    return reader;
  }

  disconnect(uuid: string) {
    const reader = this.eventStreams.get(uuid);
    if (reader) {
      reader.cancel();
      this.eventStreams.delete(uuid);
    }
  }
}
